import { useEffect, useState } from "react";

import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import ScrollToTop from "./Components/ScrollToTop/ScrollToTop";
import FloatingMobileLang from "./Components/FloatingMobileLang/FloatingMobileLang";
import FloatingCall from "./Components/FloatingCall/FloatingCall";

import Home from "./Pages/Home/Home";
import About from "./Pages/About/About";
import Contact from "./Pages/Contact/Contact";
import Terms from "./Pages/Legal/Terms";
import LegalPrivacy from "./Pages/Legal/Privacy";
import Cookies from "./Pages/Legal/Cookies";

import DataPrivacy from "./Pages/Resources/Privacy";
import DataAccuracy from "./Pages/Resources/DataAccuracy";
import DataCoverage from "./Pages/Resources/DataCoverage";
import Blog from "./Pages/Resources/Blog";
import Career from "./Pages/Resources/Career";
import Faq from "./Pages/Resources/Faq";

import Recruitment from "./Pages/Services/Recruitment";
import HireTalent from "./Pages/Services/HireTalent";
import B2BContactInsights from "./Pages/Services/B2BContactInsights";
import B2BCompanyData from "./Pages/Services/B2BCompanyData";
import DataAppending from "./Pages/Services/DataAppending";
import DataValidation from "./Pages/Services/DataValidation";
import DataVerification from "./Pages/Services/DataVerification";
import B2BAppointment from "./Pages/Services/B2BAppointment";
import EmailMarketing from "./Pages/Services/EmailMarketing";
import LeadGeneration from "./Pages/Services/LeadGeneration";
import CompanyProfiling from "./Pages/Services/CompanyProfiling";

// Normalizes paths: strips trailing slashes (except root) and converts to lowercase
const getCleanPath = () => {
  const path = window.location.pathname;
  if (path.length > 1 && path.endsWith("/")) {
    return path.slice(0, -1).toLowerCase();
  }
  return path.toLowerCase();
};

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentPath, setCurrentPath] = useState(getCleanPath());

  // Sync client-side route changes on popstate
  useEffect(() => {
    const handlePopState = () => {
      setCurrentPath(getCleanPath());
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  // Enforce instantaneous top-scroll across mobile and desktop on every route change
  useEffect(() => {
    // Release any lingering body overflow locks from mobile drawers or modals
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";

    window.scrollTo({ top: 0, left: 0, behavior: "instant" });

    // Secondary frame check for dynamic content mounting
    const frameId = requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    });

    return () => cancelAnimationFrame(frameId);
  }, [currentPath]);

  // Page routing switch
  const renderCurrentPage = () => {
    switch (currentPath) {
      // Core Pages
      case "/about":
        return <About />;
      case "/contact":
        return <Contact />;

      // Legal Pages
      case "/terms":
      case "/terms-and-conditions":
        return <Terms />;
      case "/privacy-policy":
        return <LegalPrivacy />;
      case "/cookies":
      case "/cookie-policy":
        return <Cookies />;

      // Resources
      case "/privacy":
      case "/data-privacy":
        return <DataPrivacy />;
      case "/data-accuracy":
        return <DataAccuracy />;
      case "/data-coverage":
        return <DataCoverage />;
      case "/blog":
      case "/our-blog":
        return <Blog />;
      case "/career":
      case "/careers":
        return <Career />;
      case "/faq":
      case "/faqs":
        return <Faq />;

      // Recruitment & Staffing Suite
      case "/recruitment":
      case "/services/recruitment":
        return <Recruitment />;
      case "/hire-talent":
      case "/hiring":
        return <HireTalent />;

      // Services Suite
      case "/services/b2b-contact-insights":
        return <B2BContactInsights />;
      case "/services/b2b-company-data":
        return <B2BCompanyData />;
      case "/services/data-appending":
        return <DataAppending />;
      case "/services/data-validation":
        return <DataValidation />;
      case "/services/data-verification":
        return <DataVerification />;
      case "/services/b2b-appointment":
        return <B2BAppointment />;
      case "/services/email-marketing":
        return <EmailMarketing />;
      case "/services/lead-generation":
        return <LeadGeneration />;
      case "/services/company-profiling":
        return <CompanyProfiling />;

      // Home fallback
      case "":
      case "/":
      default:
        return <Home />;
    }
  };

  return (
    <>
      {/* Global Navbar */}
      <Navbar onMenuToggle={setIsMenuOpen} currentPath={currentPath} />

      {/* Floating Edge Mobile Language Switcher */}
      {!isMenuOpen && <FloatingMobileLang />}

      {/* Persistent Call Quick-Action */}
      <FloatingCall />

      {/* Render Current Route */}
      {renderCurrentPage()}

      {/* Global Footer */}
      <Footer />

      {/* Scroll to Top Utility */}
      <ScrollToTop />
    </>
  );
}

export default App;